// This file is automatically generated. Do not edit manually.

import { IsoDateString } from "src/types/dateTime";
import { CostEventObjectRef } from "src/api/generated/erp/common/costEvents/model/costEventObjectRef";
import { CostEvent } from "src/api/generated/erp/db/types/tables/costEvent";
import { CostEventItem } from "src/api/generated/erp/db/types/tables/costEventItem";
import { CostEventView } from "src/api/generated/erp/db/types/tables/costEventView";
import { CostEventPriceListLine } from "src/api/generated/erp/db/types/tables/costEventPriceListLine";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CostEventFormApi {
	export async function getInitData(args: {
		costEventId: number | null | undefined;
		costEventPriceListId: number | null | undefined;
	}): Promise<CostEventFormApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/costEvents/costEventForm/getInitData",
			method: "POST",
			data: {
				costEventId: args.costEventId,
				costEventPriceListId: args.costEventPriceListId,
			},
		});
		return response as CostEventFormApi_InitData;
	}

	export async function createNew(args: {
		costEventItemId: number;
		description: string | null | undefined;
		quantity: number | null | undefined;
		eventDate: IsoDateString;
		objectRef: CostEventObjectRef;
		cost?: number | null | undefined;
		price?: number | null | undefined;
		explanation?: string | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/costEvents/costEventForm/createNew",
			method: "POST",
			data: {
				costEventItemId: args.costEventItemId,
				description: args.description,
				quantity: args.quantity,
				eventDate: args.eventDate,
				objectRef: args.objectRef,
				cost: args.cost,
				price: args.price,
				explanation: args.explanation,
			},
		});
		return response as number;
	}

	export async function update(args: { costEvent: CostEvent }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/costEvents/costEventForm/update",
			method: "POST",
			data: {
				costEvent: args.costEvent,
			},
		});
		return response as void;
	}
}

export interface CostEventFormApi_InitData {
	availableCostEventItems: Array<CostEventItem>;
	costEvent: CostEventView | null | undefined;
	priceListLines: Array<CostEventPriceListLine>;
}
